export const ICON_ARROW_DOWN = "itaufonts_seta_down";
//# sourceMappingURL=constants.js.map